import classNames from 'classnames';
import { BtnDoubleProps } from 'eco-design-micro/props/btn/BtnDoubleProps';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { SectionLayout } from 'eco-design-micro/props/msg/const';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoSection from 'eco-design/base/eco-section';
import React from 'react';
import BannerBtn from './BannerBtn';
import './index.scss';

export interface EcoBannerProps extends ImgVideoProps, SectionTextWithColorProps, BtnDoubleProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 展示位置
     */
    layout?: SectionLayout;
    /**
     * 高度类型
     *
     * default 默认固定高度
     *
     * full-screen 满屏
     */
    heightType?: 'default' | 'full-screen';
    /**
     * 第1个按钮是否是youtube链接
     */
    lBtnIsYouToBe?: boolean;
    /**
     * 第2个按钮是否是youtube链接
     */
    cBtnIsYouToBe?: boolean;
    /**
     * 第3个按钮是否是youtube链接
     */
    rBtnIsYouToBe?: boolean;
    /**
     * 子内容-用于邮箱访问|倒计时等-1
     */
    childrenA?: React.ReactNode;
    /**
     * 子内容-用于邮箱访问|倒计时等-2
     */
    childrenB?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
    /**
     * id
     */
    id?: string;
}

/**
 * 用于产品详情页Banner
 */
const EcoBanner: React.FC<EcoBannerProps> = ({ className, ...reset }) => {
    const props = reset || {};
    const prefixCls = `eco-banner-card`;
    const classes = classNames(prefixCls, 'GtmModuleData-section', {
        [`${className}`]: className,
        [`${prefixCls}-layout-${props.layout}`]: props.layout,
        [`${prefixCls}-theme-${props.theme}`]: props.theme,
        [`${prefixCls}-heightType-${props.heightType}`]: props.heightType,
    });
    const hasChildA = !!props.childrenA;
    const hasChildB = !!props.childrenB;
    const idA = props.id;
    return (
        <div className={classes} id={idA} data-section-id="EcoBanner" data-section-id2={idA || className || ''} data-section-title={props.title}>
            <EcoImgVideo
                isVideo={props.isVideo}
                pc={props.pc}
                h5={props.h5}
                pad={props.pad}
                autoPlay={true}
                loop={true}
                poster={props.poster}
                posterH5={props.posterH5}
                posterPad={props.posterPad}
            />
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-in`}>
                    <EcoSection {...props} />
                    <div className={`${prefixCls}-btn-box`}>
                        <BannerBtn
                            prefixCls={prefixCls}
                            lTheme={props.theme}
                            lType={props.lType}
                            lHref={props.lHref}
                            lFontColor={props.lFontColor}
                            lBgColor={props.lBgColor}
                            isYouToBe={props.lBtnIsYouToBe}
                            gtm_title={props.title}
                            dataLayer={props.lDataLayer}
                        >
                            {props.lChildren}
                        </BannerBtn>
                        <BannerBtn
                            prefixCls={prefixCls}
                            lTheme={props.theme}
                            lType={props.rType}
                            lHref={props.rHref}
                            lFontColor={props.rFontColor}
                            lBgColor={props.rBgColor}
                            isYouToBe={props.rBtnIsYouToBe}
                            gtm_title={props.title}
                            dataLayer={props.rDataLayer}
                        >
                            {props.rChildren}
                        </BannerBtn>
                    </div>
                    {hasChildA && <div className={`${prefixCls}-childrenA`}>{props.childrenA}</div>}
                </div>
                {hasChildB && <div className={`${prefixCls}-childrenB`}>{props.childrenB}</div>}
            </div>
        </div>
    );
};

export default EcoBanner;
